import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "./firebase/AuthProvider";

const ProtectedRoute = () => {
  const {
    currentUser,
    isLoading,
    requiresPasswordChange,
    needsEmailVerification,
    needsMfaEnrollment,
  } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="flex justify-center items-center h-screen">
        Loading...
      </div>
    );
  }

  else if (location.pathname.startsWith("/sign/")) {
    return <Outlet />;
  }

  else if (!currentUser) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  else if (
    requiresPasswordChange === true &&
    location.pathname !== "/change-password"
  ) {
    console.log(
      "ProtectedRoute: Password change required, redirecting to /change-password"
    );
    return (
      <Navigate to="/change-password" state={{ from: location }} replace />
    );
  }

  // if (needsEmailVerification) return <Navigate to="/verify-email" />;
  // if (needsMfaEnrollment)    return <Navigate to="/mfa-setup" />;

  else return <Outlet />;
};

export default ProtectedRoute;
